/* Qelara Image Localizer — swap de imágenes de producto por idioma en TODA la tienda.
   Mismo mecanismo que las apps de localización de imágenes (sustitución en el navegador),
   sin dependencia externa. Config: window.QIL = { map:{clave->url}, alt:{clave->alt} },
   inyectada por snippets/image-localizer.liquid según el locale. */
(function () {
  var Q = window.QIL;
  if (!Q || !Q.map) return;
  var KEYS = Object.keys(Q.map);
  if (!KEYS.length) return;

  function keyFor(u) {
    if (!u) return null;
    for (var i = 0; i < KEYS.length; i++) {
      if (u.indexOf(KEYS[i]) !== -1) return KEYS[i];
    }
    return null;
  }

  function fixImg(img) {
    if (img.dataset.qilDone) return false;
    var k = keyFor(img.getAttribute('src')) || keyFor(img.getAttribute('srcset')) ||
            keyFor(img.getAttribute('data-src')) || keyFor(img.getAttribute('data-srcset'));
    if (!k) return false;
    img.dataset.qilDone = '1';
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.src = Q.map[k];
    if (Q.alt && Q.alt[k]) img.alt = Q.alt[k];
    return true;
  }

  function fixSource(s) {
    /* <picture><source srcset=…> también puede reinstalar la original */
    if (s.dataset.qilDone) return false;
    var k = keyFor(s.getAttribute('srcset')) || keyFor(s.getAttribute('data-srcset'));
    if (!k) return false;
    s.dataset.qilDone = '1';
    s.setAttribute('srcset', Q.map[k]);
    return true;
  }

  function fixBg(el) {
    /* imágenes de fondo inline (secciones hero de Shopify) */
    if (el.dataset.qilBgDone) return false;
    var st = el.getAttribute('style');
    if (!st || st.indexOf('background') === -1) return false;
    var k = keyFor(st);
    if (!k) return false;
    el.dataset.qilBgDone = '1';
    el.style.backgroundImage = 'url("' + Q.map[k] + '")';
    return true;
  }

  function sweep(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var n = 0, i;
    var imgs = scope.querySelectorAll('img');
    for (i = 0; i < imgs.length; i++) if (fixImg(imgs[i])) n++;
    var srcs = scope.querySelectorAll('source');
    for (i = 0; i < srcs.length; i++) if (fixSource(srcs[i])) n++;
    var bgs = scope.querySelectorAll('[style*="background"]');
    for (i = 0; i < bgs.length; i++) if (fixBg(bgs[i])) n++;
    return n;
  }

  function boot() {
    sweep(document);
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'attributes') { fixImg(m.target.tagName === 'IMG' ? m.target : m.target); }
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType === 1) sweep(node);
        }
      }
    });
    mo.observe(document.documentElement, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['src', 'srcset', 'data-src', 'style']
    });
    /* respaldo para lazy-load tardío y carruseles */
    var t = 0, iv = setInterval(function () { sweep(document); if (++t > 40) clearInterval(iv); }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
